import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { Grid, CircularProgress, Button} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Dashboard as DashboardLayout } from 'layouts';
import { HeadwordProfile, HeadwordDetails } from './components';
import { state as appState } from 'App';
import service from 'services/headwords';
// Material components
import { Typography } from '@material-ui/core';
// Shared components
import { Paper } from 'components';
// Externals
import classNames from 'classnames';

const styles = theme => ({
  root: {
    padding: theme.spacing(4)
  },
  progressWrapper: {
    padding: theme.spacing(3),
    display: 'flex',
    justifyContent: 'center'
  },
});

class Headword extends Component {
  state = {
    tabIndex: 0,
    isLoading: true,
    user: appState.get('user'),
    matchingHeads: null
  };

  async getData() {
    try {
      this.setState({ isLoading: true });

      const headword = await service.getHeadword(this.props.match.params.headwordId);
      const resp = await service.searchHeadwords(headword.attributes.headword);
      const potMatches = Array.isArray(resp) ? resp : []; // your api.js returns .data directly
      let matches = [];

      if (potMatches.length > 1) {
        const dupes = potMatches.filter(hw => String(hw.id) !== String(this.props.match.params.headwordId));
        const promMatches = dupes.map(dHw => service.getHeadword(dHw.id));
        matches = await Promise.all(promMatches);   // resolve the promises

      }

      if (this.signal) {
        this.setState({
          isLoading: false,
          headword: headword,
          matchingHeads: matches.length ? matches : null
        });
      }
    } catch (error) {
      if (this.signal) {
        this.setState({
          isLoading: false,
          error
        });
      }
    }
  }

  /*componentWillMount() {
    this.signal = true;
    this.getData();
    this._unwatch = appState.watch('user', user => {
      this.setState({ user });
    });
  }*/

  componentDidMount() {
    this.signal = true;
    this.getData();
    this._unwatch = appState.watch('user', user => this.setState({ user }));
  }

  componentDidUpdate(prevProps) {
    const prevId = prevProps.match.params.headwordId;
    const currId = this.props.match.params.headwordId;
    if (prevId !== currId) {
      this.getData();        // ← refetch on param change
      window.scrollTo(0, 0); // optional: jump to top on nav
    }
  }

  componentWillUnmount() {
    this._unwatch();
    this.signal = false;
  }

  canEdit() {
    return this.state.user && this.state.user.attributes.roles.includes('editor');
  }


  renderDuplicates() {

    return (
      <div>
      {this.state.matchingHeads.map((hw) => {
        console.log(hw.id);
        let headTitle = hw.attributes.headword;
        if(hw.attributes.partOfSpeech!=null) {
          headTitle = headTitle + "-" + hw.attributes.partOfSpeech;
        }
        headTitle = headTitle + " (" + String(hw.id) + ") ";
        const cites = Array.isArray(hw.relationships.citations) ? hw.relationships.citations : [];
        headTitle = headTitle + String(cites.length) + " Quotation(s)";

        return (<Link to={`/headwords/${hw.id}`}><Typography variant="subtitle1">{headTitle}</Typography></Link>)})}
      </div>
    );      

  }

  renderDuplicateList() {
    const { classes, className } = this.props;
    const rootClassName = classNames(classes.root, className);
    if ((this.state.matchingHeads?.length ?? 0) > 0) {
      console.log(this.state.matchingHeads);
      return (
        <Paper className={rootClassName}>
          <Typography variant="h4">Potential Duplicates:</Typography>
                {this.renderDuplicates()}
        </Paper>
       
      );
    }

  }

  render() {
    const { classes, className } = this.props;
    const rootClassName = classNames(classes.root, className);
    const { headword, isLoading } = this.state;

    if (isLoading || !headword) {
      return (
        <DashboardLayout>
          <div className={classes.progressWrapper}>
            <CircularProgress />
          </div>
        </DashboardLayout>
      );
    }

    return (
      <DashboardLayout title="Keyword">
        <div className={classes.root}>
        <Link to={'/headwords'}> 
        <Button
                color="primary"
                variant="contained"
                className={classes.saveButton}
        >Back</Button>
        </Link>
        <div><br></br></div>
          <Grid container spacing={4}>
            <Grid item lg={4} md={6} xl={4} xs={12}>
              <HeadwordProfile headword={headword} isEditable={this.canEdit()} user={this.state.user}/>
              <div className={classes.content}>
                {this.renderDuplicateList()}
              </div>
            </Grid>
            <Grid item lg={8} md={6} xl={8} xs={12}>
              <HeadwordDetails headword={headword} />
            </Grid>
          </Grid>
        </div>
      </DashboardLayout>
    );
  }
}

Headword.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Headword);
